import axios from '../http'

function add(data) {
    return axios.post('/basedata/teamCoach/add', data);
}

function del(data) {
    return axios.post('/basedata/teamCoach/del', data);
}

function update(data) {
    return axios.post('/basedata/teamCoach/update', data);
}

function query(data) {
    return axios.post('/basedata/teamCoach/query', data);
}


function get(id) {
    return axios.get('/basedata/teamCoach/get?id=' + id);
}

function find(data) {
    return axios.post('/basedata/teamCoach/find', data);
}

export default {
    add,
    del,
    update,
    query,
    get,
    find
}